export default __webpack_public_path__ + "static/media/7.f3b24bf9.jpg";